<template>
  <div class="downloadApp">
    <section>
      <img :src="appImg" class="downloadApp__app-image" />
    </section>
    <div class="downloadApp__container">
      <div class="downloadApp__header">
        <div class="downloadApp__statement">
          Photo claiming is available in the {{ brandName }} app.
        </div>
        <p>Claiming is quick and easy with {{ brandName }}. Simply take a photo of your itemised receipt and/or account and submit your claim via:</p>

      </div>
      
      <div class="downloadApp__the-app">
          <div class="downloadApp__statement">
            The {{ brandName }} app
          </div>
          <p>Log in, select ‘Claims’ from the main menu and follow the prompts to submit your claim. </p>
        <a :href='appUrl' class="button downloadApp__button">DOWNLOAD APP</a>
      </div>

      <div class="downloadApp__member-area">
        <div class="downloadApp__statement">
          Your member area 
        </div>
        <p>
          Extras claims for most services can also be submitted in the member area.
        <a :href="memberAreaMakeAClaimUrl" 
          class="downloadApp__redirect-link"
          aria-label="Claim online now"
        >
          Claim online now
        </a>
        </p>
      </div>

      <template v-if="brandName === 'Frank'">
        <div class="downloadApp__frankovhc">
          <div class="downloadApp__statement frankovhc">
            Frank OVHC
          </div>
          <p>
            Frank OVHC members can submit a claim via <a href="https://member.frankaustralia.com.au/communication/make-an-enquiry" class="member-area-link" aria-label="Submit a claim via Member area Enquiries">Member area Enquiries</a> using the enquiry type - Claiming. 
          </p>
        </div>
        </template>
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/global/TextInput';
import frankApp from '@/assets/frank/frankapp.png';
import gmhbaApp from '@/assets/gmhba/gmhbaapp.png';
import appMixins from '@/mixins/appMixins';

export default {
  name: 'DownloadApp',
  mixins: [appMixins],

  components: {
    TextInput,
  },

  data() {
    return {
      theme: this.$appsettings.Theme,
      localTheme: this.$appsettings.Theme.toLowerCase(),
    };
  },

  computed: {
    appImg() {
      return this.localTheme === 'gmhba' ? gmhbaApp : frankApp;
    },
    brandName() {
      return this.localTheme === 'gmhba' ? 'GMHBA' : 'Frank';
    },
    appUrl() {
      return this.localTheme === 'gmhba'
        ? 'https://www.gmhba.com.au/campaigns/gmhba-app'
        : 'https://www.frankhealthinsurance.com.au/get-the-app';
    },
    memberAreaMakeAClaimUrl() {
      const baseUrl = this.localTheme === 'gmhba' ? 'https://member.gmhba.com.au' : 'https://member.frankhealthinsurance.com.au';
      return `${baseUrl}/claims/make-a-claim`;
    }
  },
};
</script>

<style scoped lang='scss'>
.downloadApp {
  background: var(--color-gmhba-primary);
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  left: 0;

  @include theme-frank {
    background: var(--color-frank-primary);
  }

  &__app-image {
    max-width: 311px;
  }

  &__container {
    padding: 32px 16px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    max-width: 500px;
    gap: 24px;

    p {
      margin-bottom: 0;
    }
  }

  &__header,
  &__the-app,
  &__member-area,
  &__frankovhc {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &__frankovhc {
    max-width: 450px;
    .member-area-link {
      font-weight: 400;
    }
  }
  &__the-app {
    width: 100%;

    p {
      margin-bottom: 32px;
    }
  }

  &__statement {
    color: white;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    line-height: 26px;

    @include theme-frank {
      color: black;
    }
  }

  &__redirect-link {
    color: white;
    font-size: 14px;
    text-decoration: underline;
    font-weight: 400;
    background: none;
    border: none;
    cursor: pointer;
    font-family: var(--font-gmhba);
    @include theme-frank {
      color: black;
      text-transform: none;
      font-family: var(--font-frank);
    }
  }

  &__button {
    background-color: white;
    text-decoration: none;
    color: var(--color-gmhba-primary);
    font-size: var(--text-size-04);
    font-weight: 700;
    max-width: 240px;
    font-family: var(--font-gmhba);
    cursor: pointer;

    @include theme-frank {
      background: black;
      color: white;
      font-family: var(--font-frank);
    }
  }
}

a {
  text-decoration: underline;
  font-weight: 700;

  @include theme-frank {
    color: var(--color-frank-secondary);
  }
}

p {
  color: white;
  text-align: center;
  margin-top: 8px;
  font-size: 14px;

  @include theme-frank {
    color: black;
  }
}

@media screen and (min-height: 932px) {
  .downloadApp {
    height: 100vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/DownloadApp.vue